export const mapProjectDto = (dto) => ({
    id: dto.id,
    name: dto.name,
    description: dto.description,
    companyId: dto.company_id,
    companyName: dto.company_name,
    isArchived: dto.is_archived ?? false,
});
